// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c0669d25","455":"1a83a8b6","977":"a7ba521d"}[chunkId] + ".chunk.js";
};